module.exports = __webpack_public_path__ + "img/346.04043508.png";